import Tabs from '../../js/src/tabs.js';

(function($) {
    if($('[block-name="whats-on"]').length) {
        $('[block-name="whats-on"]').each(function(index, block) {
            let tab = '.tab-group .tab-group__item';

            if($(block).find(tab).length){
                // Initalize Tabs class
                new Tabs($(block), tab);
            }

        });
    }
})(jQuery);